import { createAction } from "@reduxjs/toolkit"

export const setPageTitle = createAction<string>("appmeta/setpagetitle")
export const setDarkMode = createAction<boolean>("appmeta/setvisualmode")
